
    import "src/shared/components/CatalogueInfoSlider/index.module.scss?farm_css_modules";
    
    export default {"button": `button-e0d55f17`,"catalogueInfoContainer": `catalogueInfoContainer-e0d55f17`,"col": `col-e0d55f17`,"editForm": `editForm-e0d55f17`,"icon": `icon-e0d55f17`,"main": `main-e0d55f17`,"open": `open-e0d55f17`,"paddedRow": `paddedRow-e0d55f17`,"row1": `row1-e0d55f17`}
    